export const frequencyOptions = ['Sí', 'No'];

export const relationsQuestions = () => [
  {
    type: 'text',
    class: 'relations-questions-title',
    text: 'Antes de finalizar, nos gustaría orientar tu acompañamiento en este proceso de sanidad, para lo cual te pedimos respondas si presentas uno o varios de estos comportamientos o luchas:',
  },
  {
    type: 'text',
    class: 'relations-questions-title',
    text: 'Area Relacional y emocional',
  },
  {
    text: 'Incapacidad de relacionarse con otros',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_incapacidad_relacionarse',
  },
  {
    text: 'Timidez',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_timidez',
  },
  {
    text: 'Inseguridad personal',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_inseguridad_personal',
  },
  {
    text: 'Baja autoestima',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_baja_autoestima',
  },
  {
    text: 'Miedo a la soledad o al compromiso',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_miedo_soledad_compromiso',
  },
  {
    text: 'Relaciones dependientes',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'emotionalDisorders_relaciones_dependientes',
  },
  {
    type: 'text',
    class: 'relations-questions-title',
    text: 'Area Sexual',
  },
  {
    text: 'Masturbación',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_masturbacion',
  },
  {
    text: 'Pornografía',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_pornografia',
  },
  {
    text: 'Adulterio',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_adulterio',
  },
  {
    text: 'Fornicación',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_fornicacion',
  },
  {
    text: 'Prostitución',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_prostitucion',
  },
  {
    text: 'Confusión en la identidad de género',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'sexualAnswers_homosexualismo',
  },
  {
    type: 'text',
    class: 'relations-questions-title',
    text: 'Area salud mental',
  },
  {
    text: 'Ataques de pánico',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_ataques_panico',
  },
  {
    text: 'Intento suicida',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_intento_suicida',
  },
  {
    text: 'Descontrol emocional',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_descontrol_emocional',
  },
  {
    text: 'Manejo inadecuado de la ira',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_manejo_ira',
  },
  {
    text: 'Conductas de auto lesión',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_auto_lesion',
  },
  {
    text: 'Anorexia y/o bulimia',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_anorexia_bulimia',
  },
  {
    text: 'Adicción a las drogas',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_adiccion_drogas',
  },
  {
    text: 'Adicción a juegos de azar',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_adiccion_juegos_azar',
  },
  {
    text: 'Depresión',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_depresion',
  },
  {
    text: 'Ansiedad',
    radio: true,
    type: 'checkbox',
    options: frequencyOptions,
    id: 'misbehaviours_ansiedad',
  },
  {
    text: 'Por favor si tienes un diagnóstico confirmado clínicamente, ponlo aquí',
    type: 'input',
    notMandatory: true,
    id: 'misbehaviours_diagnostico_clinico',
  },
  {
    type: 'text',
    class: 'relations-questions-thanks',
    text: '¡Gracias por tus sinceras respuestas! Nos estaremos comunicando contigo. Recuerda que iniciamos el 20 de agosto a las 6:45 p.m. Te recomendamos llegar 20 minutos antes para realizar el registro.',
  },
  {
    type: 'habeasData',
  },
  {
    type: 'prevButton',
  },
  {
    type: 'send',
  },
];
